export class Haptics {
  public static trigger = (type: string) => {
    console.warn("Haptics not supported on web");
  };

  public static HapticFeedbackTypes = {
    impactLight: "impactLight",
  };
}
